import ApiService from '../../../../shared/services/api-service';
import commonActionCreators from '../../../../shared/store/common/action-creators';
import trainingPhasesActionsCreators from './training-phases';
import notesActionCreators from '../../notes/action-creators';

const trainingPhasesReportNotesActions = {
  fetchNotesForReport(reportGuid) {
    return async (dispatch) => {
      dispatch(trainingPhasesActionsCreators.setIsLoading('fetchNotesForReport'));
      const data = await ApiService.get(`/api/v1/reports/${reportGuid}/notes`)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(trainingPhasesActionsCreators.setIsLoading('fetchNotesForReport'));
      if (data.error) {
        dispatch(commonActionCreators.handleApiError(data.error));
      } else {
        dispatch(this.fetchNotesForReportSuccess(data));
      }
    };
  },
  fetchNotesForReportSuccess(notesResponse) {
    return (dispatch) => {
      dispatch(notesActionCreators.pushNotes(notesResponse.data));
    };
  },
};

export default trainingPhasesReportNotesActions;
